import React from 'react'
import { utility } from '../../framework/utility/utilityProvider';
import { MEDIACATEGORIES } from '../../framework/constant/constant';
import { duration } from 'moment';

const SeriesTimeLineTile = (props) => {

    let startTime = props.startTime;
    let endTime = props.endTime;
    let slot = props.slot;
    let event = props.event;
    let selectedView = props.selectedView;
    let index = props.index;
    let slotIndex = props.slotIndex;
    let timeLineIndex = props.timeLineIndex;
    let slotDuration = props.slotDuration;

    const eventStartsThisWeek = startTime <= slot.end && endTime >= slot.start;
    let borderStyle = {
        borderLeft: '0.05em solid #60B5FF',
        borderRight: '0.05em solid #60B5FF'
    };

    let firstItem = null;
    let lastItem = null;
    let cardDetails = null;
    let cardTooltip = '';

    //COLOR PREFERENCE
    let cardPreference = {
        backgroundColor : "#60B5FF",
        color : "#030303"
    }

    if (eventStartsThisWeek) {
        const eventStartWithinWeek = new Date(Math.max(startTime, slot.start));
        const eventEndWithinWeek = new Date(Math.min(endTime, slot.end));

        if (selectedView == 'day') eventEndWithinWeek.setDate(eventEndWithinWeek.getDate() + 6);

        const getDayOffsetWithinWeek = (date, weekStart) => {
            return Math.max(0, Math.min(6, Math.floor((date - weekStart) / (1000 * 60 * 60 * 24))));
        };

        const offsetDays = getDayOffsetWithinWeek(eventStartWithinWeek, slot.start);
        const spanDays = getDayOffsetWithinWeek(eventEndWithinWeek, slot.start) - offsetDays + 1;

        const percentLeft = (offsetDays / 7) * 100;
        const percentWidth = (spanDays / 7) * 100;

        let divBlockHeight = '90%';

        if (event.series && event.series.length > 0) {
            firstItem = event.series[0];
            lastItem = event.series[event.series.length - 1];

            switch (firstItem?.mediaEpisode?.MediaCategory.SID) {
                case MEDIACATEGORIES.Program:

                    cardPreference = {
                        backgroundColor: "#8F87F1",
                        color: "#030303"
                    }

                    break;

                case MEDIACATEGORIES.Movie:

                    cardPreference = {
                        backgroundColor: "#90C67C",
                        color: "#030303"
                    }

                    break;

                default:

                    cardPreference = {
                        backgroundColor: "#60B5FF",
                        color: "#030303"
                    }
                    break;
            }

            let isProgramMovie = firstItem?.mediaEpisode?.MediaCategory.SID != MEDIACATEGORIES.Episode;
            const mediaDuration = event.series[0]?.mediaEpisode?.Duration / (60 * 1000);

            //CARD DETAILS
            if(isProgramMovie){
                console.log(firstItem);


                cardDetails = {
                    title : firstItem?.mediaEpisode?.Title ?? '',
                    seasonNumber : null,
                    duration : utility.convertMilisecondsToStringWithFrames(firstItem?.mediaEpisode?.Duration),
                    from : `${utility.convertMilisecondsToDateString(firstItem?.SlotDateTime)} ${utility.convertMilisecondsToShortTimeString(firstItem?.SlotDateTime)}`,
                    to : `${utility.convertMilisecondsToDateString(lastItem?.SlotDateTime)} ${utility.convertMilisecondsToShortTimeString(lastItem?.SlotDateTime + firstItem?.mediaEpisode?.Duration)}`
                }

                cardTooltip = `Title: ${cardDetails.title} \n${cardDetails.duration ?? ''} \nScheduled From: ${cardDetails.from} \nScheduled To: ${cardDetails.to}`

            } else {

                
                cardDetails = {
                    title : firstItem?.season?.Title ?? '',
                    seasonNumber : firstItem?.season?.SeasonNumber ?? '',
                    from : `${utility.convertMilisecondsToDateString(firstItem?.SlotDateTime)} ${utility.convertMilisecondsToShortTimeString(firstItem?.SlotDateTime)}`,
                    to : `${utility.convertMilisecondsToDateString(lastItem?.SlotDateTime)} ${utility.convertMilisecondsToShortTimeString(lastItem?.SlotDateTime)}`
                }
                
                cardTooltip = `Title: ${cardDetails.title ?? ''} \nSeason Number: ${cardDetails.seasonNumber} \nScheduled From: ${cardDetails.from} \nScheduled To: ${cardDetails.to}`
            }

            let timeRangeDur = slotDuration ?? 30;

            if (mediaDuration && timeRangeDur) {
                const baseRowHeightPercent = 90;
                const variation = 60 - timeRangeDur === 0 ? 0 : 5;
                const spanFactor = mediaDuration / timeRangeDur;

                const calculatedPercent = Math.min((spanFactor * baseRowHeightPercent) + ((60 / timeRangeDur) * variation), 400);

                divBlockHeight = `${calculatedPercent}%`;
            }
            timeLineIndex = index;
        }

        return (
            <td
                key={`slot-${props.index}-${props.slotIndex}`}
                style={{
                    position: 'relative',
                    width: '200px',
                    minWidth: '200px',
                    ...borderStyle,
                }}
                title={cardTooltip}
            >
                <div
                    style={{
                        position: 'absolute',
                        left: `${percentLeft}%`,
                        width: `${percentWidth}%`,
                        height: divBlockHeight,
                        backgroundColor: cardPreference.backgroundColor,
                        color: cardPreference.color,
                        display: 'flex',
                        alignItems: 'center',
                        paddingLeft: '10px',
                        zIndex: startTime >= slot.start && startTime <= slot.end ? 2 : 1,
                        top: '4px',
                        borderTopLeftRadius: percentLeft !== 0 ? '5px' : '0',
                        borderBottomLeftRadius: percentLeft !== 0 ? '5px' : '0',
                        borderTopRightRadius: percentLeft + percentWidth !== 100 ? '5px' : '0',
                        borderBottomRightRadius: percentLeft + percentWidth !== 100 ? '5px' : '0',
                        whiteSpace: 'nowrap'
                    }}
                >
                    {firstItem?.mediaEpisode?.MediaCategory.SID == MEDIACATEGORIES.Episode && (startTime >= slot.start && startTime <= slot.end) && (
                        <span style={{ fontSize: '12px' }}>
                            <strong>{cardDetails.title ?? ''}</strong><br />
                            {cardDetails.duration && `${cardDetails.duration ?? ''}`}{cardDetails.duration && <br />}
                            {cardDetails.seasonNumber && `S - ${cardDetails.seasonNumber ?? ''}`}{cardDetails.seasonNumber && <br />}
                            From: {cardDetails.from}<br />
                            To: {cardDetails.to}
                        </span>
                    )}
                </div>
            </td>
        );
    }

    

    return <td
        key={`slot-${index}-${slotIndex}`}
        style={(() => {
            let applyBorder = false;

            if (slotDuration == 30 && (timeLineIndex == index || timeLineIndex + 1 == index)) {
                applyBorder = true;
            } else if (slotDuration == 15 && (timeLineIndex == index || timeLineIndex + 1 == index || timeLineIndex + 2 == index || timeLineIndex + 3 == index)) {
                applyBorder = true;
            }

            return applyBorder ? borderStyle : {};
        })()}
    />;
}

export default SeriesTimeLineTile